import { IndicatorColorRange } from "constants/indicatorConstants";

export const getDaysLeftIndicatorColor = (daysLeft, alertDaysLeft) => {
  if (daysLeft <= 0) {
    return IndicatorColorRange.veryHigh;
  } else if (daysLeft <= alertDaysLeft) {
    return IndicatorColorRange.high;
  }
  return "#000000";
};
export const getTimeSinceIndicatorColor = (dateDiff) => {
  if (dateDiff === 3) {
    return IndicatorColorRange.veryHigh;
  } else if (dateDiff === 2) {
    return IndicatorColorRange.high;
  } else if (dateDiff === 1) {
    return IndicatorColorRange.medium;
  } else if (dateDiff === 0) {
    return IndicatorColorRange.low;
  } else {
    return IndicatorColorRange.veryLow;
  }
};
